export default {
    LOTTO_MIX_FETCH_RESULT_REPORT: "/api/v1.0.0/drawing",
};